import { loadGA } from "loadScript";
import { initializeClarity } from "./shared/microsoft-clarity";

initializeClarity();

import("./bootstrap");

loadGA();
